import * as React from 'react';
import { IWizardInstance } from './instance';

const wizardContext = React.createContext<IWizardInstance>({} as any);

export const WizardContextProvider = wizardContext.Provider;

export const useWizardContext = () => React.useContext(wizardContext);

export const useWizardState = () => useWizardContext().state;
export const useWizardStateSelectors = () => useWizardContext().selectors;
export const useWizardActions = () => useWizardContext().actions;
